<template>
  <Dialog
    v-model:visible="isVisible"
    :header="this.headerTab"
    @hide="hide()"
    @show="show()"
    :dismissable="false"
    :draggable="false"
    :modal="true"
    :style="{ width: '20vw' }"
    :closable="false"
  >
    <span v-show="errMessage" class="p-error">{{ errMessage }}</span>
    <div class="flex align-items-center gap-3">
      <Button
        label="Email"
        @click="sendEmailConfirmation"
        text
        class="p-3 w-full p-button p-button-primary mr-2"
      ></Button>
      <Button
        label="OTP WhatsApp"
        @click="sendOTPWhatsApp"
        text
        class="p-3 w-full p-button p-button-success"
      ></Button>
    </div>
    <div v-if="this.otpAuth == true">
      <div>
        <label class="col-12">
          <center style="color: black; font-weight: bold">
            OTP has been sent to {{ this.phone }}, please check your WhatsApp
            for the OTP
          </center>
        </label>
        <FormField
          v-model="OTPCode"
          fieldClass="col-12"
          v-if="this.mode == 'ACTIVATION_ACCOUNT'"
        >
          <InputText
            type="number"
            v-model="this.OTPCode"
            placeholder="OTP Number"
            style="width: 100%"
          />
          <template #error>
            <small v-if="!OTPCode && submitted" class="p-error"
              >{{ $t("is_required").replace("Value", "OTP Number") }}
            </small>
          </template>
        </FormField>
        <Button
          type="button"
          class="p-button p-button-success"
          @click="checkOTP()"
          label="VERIFY"
          style="width: 100%"
          v-if="this.mode == 'ACTIVATION_ACCOUNT'"
        />
      </div>
    </div>
    <div v-else-if="this.emailAuth == true">
      <label class="col-12">
        <center style="color: black; font-weight: bold">
          Email has been sent to {{ this.email }}, please check your Email
        </center>
      </label>
    </div>
    <template #footer>
      <div style="padding-bottom: 25px">
        <center
          v-if="
            (this.emailAuth == true || this.otpAuth == true) &&
            this.mode == 'ACTIVATION_ACCOUNT'
          "
        >
          Resend OTP in {{ this.countDown }} second<br />
        </center>
        <center v-if="this.otpAuth == true">
          <Button
            class="p-button p-component p-button-success p-button-text"
            label="Resend OTP"
            severity="info"
            v-if="this.showLink"
            @click="sendOTP()"
            style="color: navy"
          />
        </center>
        <center v-if="this.emailAuth == true">
          <Button
            class="p-button p-component p-button-success p-button-text"
            label="Resend Email"
            severity="info"
            v-if="this.showLink"
            @click="sendEmailVerif()"
            style="color: navy"
          />
        </center>
      </div>
    </template>
  </Dialog>
</template>

<!-- 
<OTPAuth v-if="true" :isVisible="true" :userId="username" :mailUser="this.mailUser" :initialErrorMessage="errormessage"
    @hide="hideOTPAuthDialog" /> -->

<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength, sameAs, requiredIf } from "@vuelidate/validators";

export default {
  data() {
    return {
      v$: useVuelidate(),
      errMessage: null,
      url: this.$API_URL + "auth/otp_auth",
      urlSend: this.$API_URL + "auth/send_otp",
      urlSendEmail: this.$API_URL + "auth/send_verification",
      urlSendEmailPass: this.$API_URL + "auth/forgotpassword",
      OTPCode: null,
      submitted: false,
      otpAuth: false,
      emailAuth: false,
      showLink: false,
      countDown: 60,
    };
  },
  validations() {
    return {
      OTPCode: { required, minLength: minLength(6) },
    };
  },
  props: {
    model: {
      type: Object,
      default: null,
    },
    username: {
      type: String,
      default: null,
    },
    email: {
      type: String,
      default: null,
    },
    phone: {
      type: String,
      default: null,
    },
    mode: {
      type: String,
      default: null,
    },
    headerTab: {
      type: String,
      default: null,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    initialErrorMessage: {
      type: String,
      default: "",
    },
    mailUser: {
      type: String,
      default: "",
    },
  },
  // created() {
  //     this.countDownTimer()
  // },
  methods: {
    show() {
      if (this.initialErrorMessage) {
        this.errMessage = this.initialErrorMessage;
      }
    },
    hide(changeSuccess, message) {
      this.OTPCode = null;
      this.v$.$reset();
      this.errMessage = null;
      this.$emit("update:isVisible", false);
      this.$emit("hide", {
        success: changeSuccess,
        message: message,
      });
    },
    passwordClass(data) {
      if (data.showPassword == undefined) {
        data.showPassword = "pi pi-eye";
      }
      data.showPassword =
        data.showPassword == "pi pi-eye-slash" || data.showPassword == undefined
          ? "pi pi-eye"
          : "pi pi-eye-slash";
      return data.showPassword;
    },
    sendOTPWhatsApp() {
      this.otpAuth = true;
      this.emailAuth = false;
      this.sendOTP();
      this.countDownTimer();
    },
    sendEmailConfirmation() {
      this.otpAuth = false;
      this.emailAuth = true;
      this.sendEmailVerif();
      this.countDownTimer();
    },
    passwordType(data) {
      return data == "pi pi-eye" ? "pi pi-eye-slash" : "pi pi-eye";
    },
    checkOTP() {
      this.v$.$validate();
      this.submitted = true;

      var self = this;

      if (!this.v$.$error) {
        this.$emit("block-ui");
        this.v$.$reset();

        if (this.model) {
          this.model.OTPCode = this.OTPCode;
        }

        this.$axios
          .post(this.url, {
            username: this.username,
            otp: this.OTPCode,
            phone: this.phone,
          })
          .then((response) => {
            if (response.data.success) {
              self.$emit("update:model", this.model);
              self.hide(true, response.data.message);
            } else {
              this.errMessage = "Failed: " + response.data.message;
            }
            this.$emit("unblock-ui");
          })
          .catch((err) => {
            this.$emit("unblock-ui");
            console.log(err);
          });
      }
    },
    sendOTP() {
      this.errMessage = "";
      if (this.mode == "ACTIVATION_ACCOUNT") {
        this.showLink = false;
        this.countDown = 60;
        this.countDownTimer();
      }

      this.$axios
        .post(this.urlSend, {
          username: this.username,
          otp: this.OTPCode,
          phone: this.phone,
          mode: this.mode,
          email: this.email,
        })
        .then((response) => {
          if (response.data.success) {
            this.$emit("update:model", this.model);
            if (this.mode != "ACTIVATION_ACCOUNT") {
              this.hide(true, response.data.message);
            }
          } else {
            this.otpAuth = false;
            this.errMessage = "Failed: " + response.data.message;
          }
          this.$emit("unblock-ui");
        })
        .catch((err) => {
          this.$emit("unblock-ui");
          console.log(err);
        });
    },
    sendEmailVerif() {
      this.errMessage = "";
      if (this.mode == "ACTIVATION_ACCOUNT") {
        this.showLink = false;
        this.countDown = 60;
        this.countDownTimer();

        this.$axios
          .post(this.urlSendEmail, {
            username: this.username,
            otp: this.OTPCode,
            phone: this.phone,
            mode: this.mode,
          })
          .then((response) => {
            if (response.data.success) {
              this.$emit("update:model", this.model);
              //   this.hide(true, response.data.message);
            } else {
              this.errMessage = "Failed: " + response.data.message;
            }
            this.$emit("unblock-ui");
          })
          .catch((err) => {
            this.$emit("unblock-ui");
            console.log(err);
          });
      } else {
        this.$axios
          .post(this.urlSendEmailPass, {
            email: this.email,
          })
          .then((response) => {
            if (response.data.success) {
              this.$emit("update:model", this.model);
              this.hide(true, response.data.message);
            } else {
              this.errMessage = "Failed: " + response.data.message;
            }
            this.$emit("unblock-ui");
          })
          .catch((err) => {
            this.$emit("unblock-ui");
            console.log(err);
          });
      }
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      } else this.showLink = true;
    },
  },
  emits: ["hide", "block-ui", "unblock-ui"],
};
</script>
